<template lang="html">
  <svg xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" height="48" width="48" version="1.1" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" viewBox="0 0 48.000002 48.000001">
   <g transform="translate(.0000046973 -1004.4)">
    <g transform="translate(-277.51 605.11)">
     <circle :style="{'fill': circleFill}" cx="301.51" cy="423.25" r="24"/>
    </g>
    <g transform="matrix(.53634 0 0 .53634 8.7143 1013.1)">
     <path style="stroke:#424a60;stroke-width:4;stroke-miterlimit:10;stroke-linecap:round;fill:none" d="m16.5 28v-15.399c0-5.831 5.175-10.601 11.5-10.601s11.5 4.77 11.5 10.601v15.399h-23z"/>
     <rect style="fill:#ebba16" height="32" width="42" y="25" x="7.5"/>
     <path style="fill:#424a60" d="m28.5 45c-1.65 0-3-1.35-3-3v-6c0-1.65 1.35-3 3-3s3 1.35 3 3v6c0 1.65-1.35 3-3 3z"/>
     <rect style="fill:#38454f" height="6" width="42" y="51" x="7.5"/>
    </g>
   </g>
  </svg>

</template>

<script>
export default {
  name: 'Permission',
  props: {
    circleFill: {
      default: '#bdcdda'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/icons/menu/Permission.vue